module.exports = __webpack_public_path__ + "images/emoji/toilet.8872deeb7a995710bacc.png";